import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

@Pipe({
  standalone: true,
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string | null | undefined, limit = 25, completeWords = false, ellipsis = '...') {
    if (isNil(value) || value === '' || value === 'null') {
      return '';
    }
    if (!limit) {
      return value;
    }

    let _limit = limit;
    let _ellipsis = ellipsis;
    if (completeWords && value.length >= _limit) {
      _limit = value.substring(0, limit).lastIndexOf(' ');
    }
    if (value.substring(0, _limit).length >= value.length) {
      _ellipsis = '';
    }
    return `${value.substring(0, _limit)}${_ellipsis}`;
  }
}
